import * as React from 'react';

import { IconButton } from '@botco/library';
import { DeleteIcon } from '@botco/library/icons';

import * as S from './APICardButton.styles';

type PropsType = React.PropsWithChildren<{
  onDelete: () => void;
}>;

export const APICardButton = (props: PropsType) => {
  return (
    <S.Wrapper>
      {props.children}
      <IconButton
        size="small"
        className="deleteIconButton"
        onClick={props.onDelete}
      >
        <DeleteIcon />
      </IconButton>
    </S.Wrapper>
  );
};
